import { merge } from '@syncfusion/ej2-base';
/**
 * Cell
 * @hidden
 */
var Cell = /** @class */ (function () {
    function Cell(options) {
        this.isSpanned = false;
        this.isRowSpanned = false;
        merge(this, options);
    }
    Cell.prototype.clone = function () {
        var cell = new Cell({});
        merge(cell, this);
        return cell;
    };
    return Cell;
}());
export { Cell };



//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/node_modules/@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-grids/src/grid/models/cell.js
// module id = ../../../../@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-grids/src/grid/models/cell.js
// module chunks = vendor